import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTime', bringozTime);

function bringozTime($filter, splitService, moment) {
  function doFilter(_date, timeZoneId) {
    const format = splitService.getDateAndTimeConfig().time;

    if (timeZoneId) {
      return moment(_date).tz(timeZoneId).format(format || 'HH:mm');
    } else if (!timeZoneId) {
      return moment(_date).format(format || 'HH:mm');
    }
  }

  return function (object, ref, defaultValue, timeZoneId) {
    if (object && object[ref]) {
      return doFilter(object[ref], timeZoneId);
    } else {
      if (_.isUndefined(defaultValue)) {
        defaultValue = '---';
      }
      return defaultValue;
    }
  }
}
